import styled from "styled-components";

const TextPage = styled.div`
  max-width: 632px;

  p {
    margin-bottom: 1em;
    margin-top: 0;
    text-align: justify;
  }
`;

export default TextPage;
